import { plainToInstance } from 'class-transformer';
import { List } from 'models/basic/List';
import api, { CrudRestApi } from '../../api';
import { User } from 'models/nostradamus/user/User';

const apiUrl = 'api/analytics/auth';
const rest = CrudRestApi(apiUrl, User);

// const getUsersList = async params => {
//     const response = await api.get(`${apiUrl}/users`, {
//         params,
//     });
//     return plainToInstance(List, response.data);
// };

const getUsersList = async () => {
    const response = await api.get(`${apiUrl}/users`);
    return plainToInstance(List, response.data);
};

const createUser = async data => {
    return api.post(`${apiUrl}/user`, data);
};

const deleteUser = async userId => {
    return api.delete(`${apiUrl}/user/${userId}`);
};

const updateUserInfo = async (data, userId) => {
    return api.put(`${apiUrl}/user/${userId}`, data);
};

const getUser = async userId => {
    const { data } = await api.get(`${apiUrl}/user/${userId}`);
    return plainToInstance(User, data.data[0], { exposeDefaultValues: true });
};

const getCurrentUser = async () => {
    const { data } = await api.get(`${apiUrl}/me`);
    return plainToInstance(User, data?.body, { exposeDefaultValues: true });
};

const getRoles = async () => {
    return api.get(`${apiUrl}/roles`);
};

const resetPassword = async userId => {
    return api.post(`${apiUrl}/user/${userId}/password/reset`);
};

const impersonate = async userId => {
    return api.post(`${apiUrl}/user/${userId}/impersonate`);
};

const toggleEnabled = async userId => {
    return api.put(`${apiUrl}/user/${userId}/toggle-enabled`);
};

const UserService = {
    ...rest,
    create: createUser,
    update: updateUserInfo,
    getList: getUsersList,
    getEntity: getUser,
    resetPassword,
    impersonate,
    toggleEnabled,
    delete: deleteUser,
    getCurrentUser,
    getRoles,
};

export default UserService;
